//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHint: false,
            result: {},
            numFound: 0,
            clickAreas: [
                {
                    x: 1080,
                    y: 325
                },
                {
                    x: 732,
                    y: 603
                },
                {
                    x: 512,
                    y: 430
                },
                {
                    x: 375,
                    y: 305
                },
                {
                    x: 30,
                    y: 480
                }
            ]
        };
    }
};
